import GalleryWixCodeApi from './wixCodeApi';
import { utils } from '../../utils/workerUtils';
import { PRO_GALLERY } from '../../constants';
import CommonViewerScript from '../../common/CommonBlueprintsViewerScript';
import Context from '../../common/ViewerScriptContext';

const context = new Context(PRO_GALLERY.SENTRY_DSN);
const WIDGET_ARRAY = [
  PRO_GALLERY.GALLERY_WIDGET_ID,
  PRO_GALLERY.PG_TEST_GALLERY_WIDGET_ID,
];
const galleryWixCodeApi = new GalleryWixCodeApi();

const createAppController = (controllerConfig) => {
  const { setProps } = controllerConfig;
  if (!WIDGET_ARRAY.includes(controllerConfig.type)) {
    return {
      pageReady: () => {},
      exports: () => {},
    };
  }

  const commonViewerScript = new CommonViewerScript(
    context,
    controllerConfig,
    PRO_GALLERY.PG_APP_DEFINITION_ID,
    PRO_GALLERY.GALLERY_WIDGET_ID,
  );
  const tryToReportAppLoaded = commonViewerScript.getTryToReportAppLoaded();
  return {
    pageReady: () => {
      try {
        const renderGallery = (viewPortState) => {
          let notInView = false;
          if (viewPortState && !viewPortState.in) {
            // notInView can be true only in SSR.
            // tryToReportAppLoaded for this case will be called later here in "if (commonViewerScript.isSSR())"
            notInView = true;
          }
          return Promise.all([
            commonViewerScript.getBlueprintPromise(),
            commonViewerScript.getDirectFullscreenPromise(),
          ])
            .catch((e) => {
              commonViewerScript.sentryReport(e);
              console.error('Waiting for promises failed', e);
            })
            .then((resArray) => {
              const [blueprint] = resArray;
              if (utils.isVerbose()) {
                console.log(
                  'query: ',
                  JSON.stringify(commonViewerScript.getQueryParams()),
                );
              }
              setProps({
                ...commonViewerScript.getCommonGalleryProps(false),
                onItemClicked: commonViewerScript.getOnItemClickedFunc(
                  galleryWixCodeApi,
                ),
                onLinkNavigation: commonViewerScript.getOnLinkNavigationFunc(),
                setMetaTags: commonViewerScript.getSetMetaTagsFunc(),
                onCurrentItemChanged: (item) =>
                  galleryWixCodeApi.onCurrentItemChanged(item),
                isInSEO: commonViewerScript.isInSEO(),
                cssBaseUrl: commonViewerScript.getbaseUrls()
                  .santaWrapperBaseUrl,
                directFullscreenItem: commonViewerScript.getDirectFullscreenItem(),
                testType: commonViewerScript.getTestType(),
                SSRWorkerLog: commonViewerScript.getSSRWorkerLog(),
                clickedIdx: commonViewerScript.getClickedIdx(),
                notInView,
                totalItemsCount: commonViewerScript.getTotalItemsCount(),
                ...blueprint,
              });

              if (commonViewerScript.isSSR()) {
                commonViewerScript.setMetaTagsInSSRIfNeeded();
                tryToReportAppLoaded(true);
              }
              return commonViewerScript.getWarmupData();
            });
        };

        return commonViewerScript
          .getViewPortPromise()
          .then(renderGallery)
          .catch((error) => {
            console.error(error);
            commonViewerScript.sentryReport({
              errorMessage: 'viewportPromise rejected!',
              error,
            });
            tryToReportAppLoaded();
          });
      } catch (e) {
        console.error(e);
        commonViewerScript.sentryReport(e);
      }
    },
    updateConfig: () => {},
    exports: () => {
      try {
        return galleryWixCodeApi.generateApi({
          proGalleryStore: commonViewerScript.getPgStore(),
          setNewItems: commonViewerScript.getSetNewItemsFunc(),
          setNewStyleParams: (sp) =>
            commonViewerScript.handleNewStyleParams(sp),
          setClickedIdx: (clickedIdx) =>
            commonViewerScript.setClickedIdx(clickedIdx),
        });
      } catch (e) {
        commonViewerScript.sentryReport(e);
      }
    },
  };
};

export const wrappedFunctions = {
  initAppForPage: CommonViewerScript.getInitAppForPageFunc(context),
  createControllers: CommonViewerScript.getCreateControllers(
    createAppController,
    context.getSentry(),
  ),
};
